<template>
  <a-modal
    :title="createPro"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="500px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div
      v-if="isMember"
      class="create-tip"
    >
      是否关联已有询盘管理项目？<br>
      关联后系统将根据询盘数据自动生成会员数据至该会员管理项目。
    </div>
    <div class="creat-dilog-form">
      <a-form
        ref="createForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${projectNameTit}：`"
          prop="projectname"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
          class="total-input-box"
        >
          <a-input
            v-decorator="decorators.projectname"
            type="text"
            :placeholder="projectnamePlace"
            :maxlength="20"
            @change="getValue"
          />
          <span class="input-length-num">{{ valData?valData.length : 0 }}/20</span>
        </a-form-item>
        <a-form-item
          :label="`${chargeTit}：`"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-decorator="decorators.adminid"
            show-search
            mode="multiple"
            :filter-option="false"
            :not-found-content="emptyTip"
            :placeholder="chargePersonPlace"
            @search="handleSearch"
            @blur="handleBlur"
          >
            <a-select-option
              v-for="(item, index) in adminListDatas"
              :key="index"
              :label="`${item.truename}`"
              :value="item.userid"
            >
              {{ item.truename }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="isMember"
          class="related-project-item"
          label="询盘管理"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-radio-group
            name="radioGroup"
            :value="isrelated"
            @change="setRelate"
          >
            <a-radio :value="1">
              关联
              <div
                v-if="isrelated === 1"
                class="related-projects-list"
              >
                <a-select
                  v-decorator="decorators.pid"
                  :filter-option="false"
                  :not-found-content="emptyTip"
                  placeholder="请选择关联项目"
                  @search="handleProSearch"
                >
                  <a-select-option
                    v-for="item in datas[1]"
                    :key="item.projectid"
                    :label="`${item.projectname}`"
                    :value="item.projectid"
                  >
                    {{ item.projectname }}
                  </a-select-option>
                </a-select>
              </div>
            </a-radio>
            <div>
              <a-radio :value="0">
                不关联
              </a-radio>
            </div>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from '@/lib/utils'

export default {
  props: {
    cId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      valData: '',
      createForm: {
        projectname: '',
        adminid: [],
        cid: this.cId
      },
      isrelated: 1
    }
  },
  computed: {
    ...mapState('organization/org', ['adminListDatas', 'decorators', 'projectType', 'datas']),
    createPro () {
      return this.isMember ? '创建会员管理项目' : '创建询盘管理项目' // this.$t('message["127"]')
    },
    chargeTit () {
      return this.$t('message["330"]')
    },
    projectnamePlace () {
      return this.$t('message["814"]')
    },
    chargePersonPlace () {
      return this.$t('message["861"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    projectNameTit () {
      return this.$t('message["1325"]')
    },
    emptyTip () {
      return this.$t('message["1551"]')
    },
    isMember () {
      return this.projectType === 'member'
    }
  },
  watch: {
    async isLimitDialogShow (val) {
      if (val) {
        this.fetchAdminId({ cid: this.cId })
      }
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    this.handleSearch = debounce(this.handleSearch, 1000)
  },
  methods: {
    ...mapActions('organization/org', ['ajaxCreateProject', 'getAdminId']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = Object.assign(values, {
            cid: this.cId,
            pType: this.isMember ? 2 : 1
          })
          const memberDatas = this.isMember ? { isrelated: this.isrelated } : {}

          const chain = await this.ajaxCreateProject({ cid: this.cId })
          chain
            .params({ ...formDatas, ...memberDatas })
            .setForm(this.form)
            .fetch()

          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    },
    async handleSearch (val) {
      try {
        const chain = await this.getAdminId()
        chain
          .params({
            cid: this.cId,
            keywords: val
          })
          .fetch()
      } catch (error) {
        console.log(error)
      }
    },
    handleBlur () {
      this.fetchAdminId({ cid: this.cId })
    },
    async handleProSearch (val) {

    },
    getValue (e) {
      this.valData = e.target.value
    },
    async fetchAdminId (val) {
      const chain = await this.getAdminId()
      chain
        .params(val)
        .fetch()
    },
    setRelate (e) {
      this.isrelated = e.target.value * 1
    }
  }
}
</script>

<style lang="scss" scoped>
.input-length-num {
  position: absolute;
  right: 6px;
  top: -8px;
}
.create-tip {
  background: #E8F4FF;
  padding: 8px 24px;
  border-top : 1px solid #4CA0F2;
  border-bottom : 1px solid #4CA0F2;
  line-height: 24px;
  margin: -24px -24px 24px;
}
.related-project-item ::v-deep {
  border-top:  1px dashed #d6d6d6;
  padding-top: 16px;
  .ant-radio-wrapper {
    line-height: 32px;
    // margin-bottom: -24px;
  }
}
.related-projects-list {
  padding-top: 10px;
  margin-bottom: -10px;
}
</style>
